export default __webpack_public_path__ + "static/logo-34d83e400f60675d8b90e1bda9967f37.svg";